import React from "react";
import styled from "styled-components";
import { Card } from "antd";
import {
  PieChart,
  Pie,
  BarChart,
  Bar,
  Legend,
  Cell,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
} from "recharts";

const Customstyle = styled.div`
  .top {
    display: flex;
    align-items: center;
    background-color: white;
    height: 140px;
    padding-top: 90px !important;
    padding-bottom: 50px !important;
    border-radius: 8px;
    line-height: 35px;
  }
  .section1,
  .section2 {
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: center;
    position: relative;
  }
  .section1::after {
    content: "";
    position: absolute;
    top: 10%;
    right: 0;
    bottom: 0;
    width: 1px;
    height: 55%;
    background-color: #d0d5dd;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
  }
  .title1 {
    font-size: 32px;
    font-weight: 600;
  }
  .title3 {
    color: #5f6d8c;
    font-size: 14px;
    font-weight: 500;
  }
  .carddiv {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .card-item {
    flex: 1;
    max-width: 49%;
    box-sizing: border-box;
    font-family: Inter;
    font-weight: 500;
    font-size: 16px;
    line-height: 19.36px;
  }
  .bottom-card {
    width: 100%;
    max-width: 100% 
    max-height: 478px;
    margin-top: 24px;
    margin-bottom: 24px;
  }
      .legend-container {
    width: 200.2649688720703px;
    height: 243px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-left: 20px;
    margin-bottom: 100px;
  }
  .legend-item {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .legend-color {
    width: 40.69873046875px;
    height: 13.566245079040527px;
    border-radius: 13.57px;
  }
  .legend-text {
    width: 146px;
    height: 21px;
    font-weight: 400;
    font-size: 15.83px;
    line-height: 20.61px;
  }
  .pie-label {

top: 32px;
left: 134px;

    font-weight: 400;
    font-size: 15.83px;
    line-height: 20.61px;
    text-align: center;
    background: #ffffff;
    width: 23px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
}
      .bar-chart .recharts-bar-rectangle {
    width: 123px !important;
    height: 36px !important;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  @media screen and (max-width: 768px) {
    .card-item {
      max-width: 100%;
    }
    .bottom-card {
      width: 100%;
      height: 478px;
    }
  }
`;

function Demographics() {
  const COLORS = ["#65A3FF", "#CE65FF", "#FFC760"];
  const data01 = [
    { name: "Male", value: 56 },
    { name: "Female", value: 46 },
    { name: "Others", value: 65 },
  ];

  const pieData = [
    { name: "Truck", value: 16 },
    { name: "Pickup", value: 6 },
    { name: "Trailer", value: 8 },
    { name: "Van", value: 10 },
    { name: "Saloon Car", value: 12 },
    { name: "Motor Cycle", value: 10 },
    { name: "Tuk Tuk", value: 14 },
  ];
  const COLORS1 = [
    "#00E070",
    "#2E79DA",
    "#1286B0",
    "#47D4FF",
    "#6EA4CF",
    "#7D6ECF",
    "#CF6EA5",
  ];
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    percent,
    outerRadius,
    index,
  }) => {
    const labelXPositions = [60, 260, 460]; // Adjust X positions for labels
    const labelYPosition = 20; // Fixed Y position at the top
    const squareSize = 14;
    const color = COLORS[index % COLORS.length];

    // Calculate the position of the label
    const RADIAN = Math.PI / 180;
    const radius = outerRadius * 0.8;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <>
        <rect
          x={labelXPositions[index] - squareSize - 5} // Adjust X position for squares
          y={labelYPosition - squareSize / 2} // Align with text
          width={squareSize}
          height={squareSize}
          fill={color}
        />
        <text
          x={labelXPositions[index]}
          y={labelYPosition}
          fill="#5F6D8C"
          textAnchor="start"
          dominantBaseline="central"
          fontSize={12}
        >
          {data01[index].name}
        </text>
      </>
    );
  };

  const renderCustomizedLabel1 = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#FFFFFF"
        textAnchor="middle"
        dominantBaseline="central"
        className="pie-label"
      >
        {`${value}`}
      </text>
    );
  };

  // Sample Data
  const data = [
    {
      name: "William Joseph Becquerel1",
      category: "Fresh Beginner\nA1/ A2/ A3 (Motor Bike/\nCourier/ 3-Wheeler",
      value: 2,
      color: "#5668E2",
    },
    {
      name: "William Joseph Becquerel2",
      category: "Endorsement\nA1/ A2/ A3 (Motor Bike/\nCourier/ 3-Wheeler",
      value: 2,
      color: "#CF56E2",
    },
    {
      name: "William Joseph Becquerel3",
      category: "Fresh Beginner\nB1/ B2 (Saloon -\nAuto/ Manual)",
      value: 3,
      color: "#E28956",
    },
    {
      name: "William Joseph Becquerel4",
      category: "Endorsement(PLV)\nB1/ B2 (Saloon -\nAuto/ Manual)",
      value: 4,
      color: "#E25688",
    },
    {
      name: "William Joseph Becquerel5",
      category: "Endorsement\nC1/ C2 (Medium Trucks)",
      value: 5,
      color: "#1EABFA",
    },
    {
      name: "William Joseph Becquerel6",
      category: "Endorsement\nD1/ D2 (PSV)",
      value: 6,
      color: "#72E256",
    },
  ];

  // Unique categories for X-Axis
  const categories = [...new Set(data.map((d) => d.category))];

  // Unique users for Y-Axis
  const users = [...new Set(data.map((d) => d.name))];

  // Transform data to match Recharts Scatter format
  const transformedData1 = users.flatMap((user, userIndex) =>
    data
      .filter((d) => d.name === user)
      .map((d) => ({
        x: categories.indexOf(d.category),
        y: userIndex,
        color: d.color,
      }))
  );

  const CustomXAxisTick = ({ x, y, payload }) => {
    const categoryText = categories[payload.value];
    if (!categoryText) return null;
  
    const lines = categoryText.split("\n"); // Split into multiple lines
  
    return (
      <g transform={`translate(${x},${y + 10})`}> {/* Adds vertical gap */}
        {lines.map((line, index) => (
          <text
            key={index}
            x={0}
            y={index * 18} // Controls spacing between lines
            textAnchor="middle"
            fontSize={12}
            fill={index === 0 ? "#363636" : "#5F6D8C"}
            fontWeight={index === 0 ? "400" : "300"}
          >
            {line}
          </text>
        ))}
      </g>
    );
  };
  
  
  
  
  

  //   const scatterData = Array.from({ length: 13 }, (_, index) =>
  //     xLabels.map((label, col) => ({ x: label, y: yLabels[index], z: 100 }))
  //   ).flat();

  const barChartData = [
    { name: "Truck", value: 20 },
    { name: "Pickup", value: 14 },
    { name: "Trailer", value: 22 },
    { name: "Van", value: 10 },
    { name: "Saloon Car", value: 8 },
    { name: "Motor Cycle", value: 18 },
    { name: "Tuk Tuk", value: 4 },
  ];

  const ageData = [
    { category: "30 & Less", Male: 12, Female: 12, Others: 12 },
    { category: "31 - 40", Male: 10, Female: 9, Others: 4 },
    { category: "41 - 50", Male: 6, Female: 7, Others: 3 },
    { category: "51 - 60", Male: 14, Female: 10, Others: 5 },
    { category: "Above 60", Male: 5, Female: 4, Others: 2 },
  ];

  const transformedData = ageData.map((item) => ({
    category: item.category,
    Male: item.Male,
    Female: item.Female + item.Male,
    Others: item.Others + item.Female + item.Male,
  }));

  return (
    <Customstyle>
      <div className="top">
        <div className="section1">
          <p className="title">Total No. of Drivers</p>
          <p className="title1">
            100 <br />
            <span className="title3"></span>
          </p>
          <br />
        </div>
        <div className="section1">
          <p className="title">Male</p>
          <p className="title1">
            45 <br />
            <span className="title3">45%</span>
          </p>
        </div>
        <div className="section1">
          <p className="title">Female</p>
          <p className="title1">
            45 <br />
            <span className="title3">45%</span>
          </p>
        </div>
        <div className="section2">
          <p className="title">Others</p>
          <p className="title1">
            10 <br />
            <span className="title3">10%</span>
          </p>
        </div>
      </div>
      <br />
      <div className="carddiv">
        <Card className="card-item">
          <p>Gender Diversity</p>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data01}
                cx="50%"
                cy="50%"
                innerRadius={75}
                outerRadius={110}
                paddingAngle={-15}
                cornerRadius={40}
                dataKey="value"
                startAngle={270} // Starts at the top
                endAngle={-270}
                label={renderCustomizedLabel}
                labelLine={false}
              >
                {data01.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Card>
        <Card className="card-item">
          <p>Age Category</p>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={transformedData}
              layout="vertical"
              margin={{ left: 0 }}
            >
              <CartesianGrid
                vertical={true}
                horizontal={false}
                stroke="#E0E0E0"
                strokeDasharray="none"
              />
              <XAxis
                type="number"
                axisLine={false}
                tickLine={false}
                interval={0}
                domain={[0, 20]}
                tickCount={11}
                tick={{ textAnchor: "start", fontSize: 13 }}
              />
              <YAxis
                dataKey="category"
                type="category"
                width={100}
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 13 }}
              />
              <Tooltip />
              <Legend
                layout="horizontal"
                verticalAlign="top"
                align="right"
              />{" "}
              <Bar
                dataKey="Male"
                fill="#75CDFF"
                stackId="a"
                barSize={36}
                radius={[0, 8, 8, 0]}
              />
              <Bar
                dataKey="Female"
                fill="#FF77A7"
                stackId="a"
                barSize={36}
                radius={[0, 8, 8, 0]}
              />
              <Bar
                dataKey="Others"
                fill="#59E671"
                stackId="a"
                barSize={36}
                radius={[0, 8, 8, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </div>

      <Card className="bottom-card">
        <p className="card-item">Driver Classes</p>
        <div style={{ width: "100%", height: "400px", overflowY: "auto" }}> 

        <ResponsiveContainer width="100%" height={400}>
          <ScatterChart width={1000} height={400} margin={{ top: 10, left: 100, bottom: 30}}>
            <CartesianGrid
              vertical={false}
              horizontal={true}
              stroke="#5F6D8C"
              strokeDasharray="none"
            />

            <XAxis
              type="category"
              dataKey="x"
              domain={[0, categories.length - 1]}
              tickFormatter={(tick) => categories[tick]}
              tick={<CustomXAxisTick />}
              interval={0}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              type="name"
              dataKey="y"
              domain={[0, users.length - 1]}
              tickFormatter={(tick) => (users[tick] ? users[tick] : "")} // Ensure all labels appear
              tick={{
                fontSize: 12,
                width: 194,
                textAnchor: "end",
                whiteSpace: "nowrap",
              }}
              axisLine={false}
              tickLine={false}
              interval={0}
            />
            <Tooltip />
            <Scatter
              data={transformedData1}
              shape={(props) => (
                <circle
                  cx={props.cx}
                  cy={props.cy}
                  r={10}
                  fill={props.payload.color}
                />
              )}
            />
          </ScatterChart>
        </ResponsiveContainer>
        </div>
      </Card>

      <div className="carddiv">
        <Card className="card-item">
          <p>Vehicle Types</p>
          <ResponsiveContainer width="100%" height={300}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <PieChart
                width={400}
                height={400}
                margin={{ top: 0, right: 0, left: 0, bottom: 80 }}
              >
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  innerRadius="34%"
                  outerRadius="69%"
                  fill="#8884d8"
                  paddingAngle={2}
                  dataKey="value"
                  label={renderCustomizedLabel1}
                  labelLine={false}
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS1[index % COLORS1.length]}
                    />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>

              <div className="legend-container">
                {pieData.map((entry, index) => (
                  <div key={index} className="legend-item">
                    <div
                      className="legend-color"
                      style={{
                        backgroundColor: COLORS1[index % COLORS1.length],
                      }}
                    ></div>
                    <span className="legend-text">{entry.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </ResponsiveContainer>
        </Card>
        <Card className="card-item">
          <p>Drivers based on Vehicle Types</p>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
              barSize={36}
              data={barChartData}
            >
              <CartesianGrid vertical={false} horizontal={false} />
              <XAxis
                dataKey="name"
                tickLine={false}
                axisLine={false}
                interval={0}
                tick={{
                  fontSize: 11,
                }}
              />
              <YAxis
                dataKey="value"
                axisLine={false}
                tickLine={false}
                interval={0}
                domain={[0, 24]}
                tickCount={13}
                tick={{
                  fontSize: 11,
                }}
              />
              <Tooltip />
              {/* <Legend /> */}
              <Bar dataKey="value" fill="#6DB6FF" radius={[5, 5, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </div>
    </Customstyle>
  );
}
export default Demographics;
